import React from "react";
import { useTheme } from '../context/ThemeContext';

const Loading = () => {
  const { isDark } = useTheme();

  const handleImageError = (img) => {
    if (!img) return;
    img.style.display = "none";
    const box = document.getElementById("logo-box");
    if (box) {
      box.style.backgroundColor = "rgba(255,255,255,0.05)";
      box.style.backgroundImage = "url('/logo.png')";
      box.style.backgroundSize = "contain";
      box.style.backgroundPosition = "center";
      box.style.backgroundRepeat = "no-repeat";
    }
  };

  return (
    <div className="loading-root">
      <div className="logo-wrapper" id="logo-box">
        <img
          src="/logo.png"
          alt="Logo"
          className="logo-image"
          onError={(e) => handleImageError(e.currentTarget)}
        />
        <div className="glitch-layer layer-red" />
        <div className="glitch-layer layer-blue" />
      </div>
      
      <div className="loading-text">Loading</div>

      <style>{`
        .loading-root {
            width: 100%;
            min-height: calc(100vh - 200px);
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            background-color: transparent;
            gap: 2rem;
        }

        .logo-wrapper {
            position: relative;
            width: 200px;
            height: 200px;
            display: flex;
            justify-content: center;
            align-items: center;
        }

        @media (min-width: 640px) {
            .logo-wrapper {
                width: 250px;
                height: 250px;
            }
        }

        .logo-image {
            max-width: 100%;
            max-height: 100%;
            object-fit: contain;
            position: relative;
            z-index: 5;
            filter: drop-shadow(0 0 ${isDark ? '8px' : '5px'} rgba(${isDark ? '0,255,242' : '14,165,233'},${isDark ? '0.3' : '0.2'}));
        }

        .glitch-layer {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background-image: url('/logo.png');
            background-size: contain;
            background-position: center;
            background-repeat: no-repeat;
            opacity: 0.8;
            pointer-events: none;
        }

        .layer-red {
            left: 4px;
            filter: drop-shadow(-3px 0 ${isDark ? '#ff00c1' : '#ec4899'}) saturate(300%) contrast(150%);
            animation: glitch-anim-1 2s infinite steps(1);
            z-index: 3;
        }

        .layer-blue {
            left: -4px;
            filter: drop-shadow(3px 0 ${isDark ? '#00fff2' : '#0ea5e9'}) saturate(300%) contrast(150%);
            animation: glitch-anim-2 1.5s infinite steps(1) reverse;
            z-index: 4;
        }

        @keyframes glitch-anim-1 {
            0% { clip-path: inset(10% 0 70% 0); transform: translate(-8px, -3px); }
            10% { clip-path: inset(50% 0 30% 0); transform: translate(8px, 3px); }
            20% { clip-path: inset(20% 0 60% 0); transform: translate(-6px, 6px); }
            30% { clip-path: inset(70% 0 10% 0); transform: translate(6px, -6px); }
            40% { clip-path: inset(40% 0 40% 0); transform: translate(-8px, -3px); }
            50% { clip-path: inset(10% 0 80% 0); transform: translate(8px, 3px); }
            60% { clip-path: inset(80% 0 5% 0); transform: translate(-3px, 8px); }
            70% { clip-path: inset(30% 0 50% 0); transform: translate(3px, -8px); }
            80% { clip-path: inset(60% 0 20% 0); transform: translate(-8px, 3px); }
            90% { clip-path: inset(5% 0 85% 0); transform: translate(8px, -3px); }
            100% { clip-path: inset(40% 0 40% 0); transform: translate(0); }
        }

        @keyframes glitch-anim-2 {
            0% { clip-path: inset(5% 0 85% 0); transform: translate(6px, 4px); }
            20% { clip-path: inset(80% 0 10% 0); transform: translate(-6px, -4px); }
            40% { clip-path: inset(30% 0 50% 0); transform: translate(6px, 2px); }
            60% { clip-path: inset(60% 0 20% 0); transform: translate(-6px, -2px); }
            80% { clip-path: inset(15% 0 75% 0); transform: translate(4px, 6px); }
            100% { clip-path: inset(50% 0 40% 0); transform: translate(0); }
        }

        .loading-text {
            color: ${isDark ? '#00fff2' : '#0ea5e9'};
            font-size: 1.5rem;
            font-weight: bold;
            text-transform: uppercase;
            letter-spacing: 0.3rem;
            animation: pulse 1.5s ease-in-out infinite;
        }

        @media (min-width: 640px) {
            .loading-text {
                font-size: 2rem;
            }
        }

        .loading-text::after {
            content: '...';
            animation: dots 1.5s steps(4, end) infinite;
        }

        @keyframes pulse {
            0%, 100% { 
                opacity: 1; 
                transform: scale(1);
            }
            50% { 
                opacity: 0.5;
                transform: scale(1.05);
            }
        }

        @keyframes dots {
            0%, 20% { content: ''; }
            40% { content: '.'; }
            60% { content: '..'; }
            80%, 100% { content: '...'; }
        }
      `}</style>
    </div>
  );
};

export default Loading;